import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';
// import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import TagsInput from '../navigation/TagsInput';
import {changeHomeTab,createDatatype} from '../store/actions/CommonAction'
import { TimeoutLogic } from '../utils/TimeoutLogic';
import { useDispatch } from 'react-redux';
import { Modal } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import {getDatatype} from '../store/actions/CommonAction'



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const CreateData = ({ open, onClose }, props) => {

    const dispatch = useDispatch();
    const [datatype,setDatatype] = useState(null);
    const [format,setFormat] = useState('');
    const [consentType,setconsentTypes] = useState();
    const [show, setShow] = useState(false);
    const [showDataTypeSuccess, setShowDataTypeSuccess] = useState(false);
    const [showDataTypeModal, setShowDataTypeModal] = useState(false);

  const [values, setValues] = useState({
    select1: '',
  });

    const selectedTags = tags => {
    setconsentTypes(tags)
    };

    const save = async( event) =>{
        event.preventDefault();
        try{
            await dispatch(createDatatype(datatype,format,consentType)) 
            await handleShow()
        }catch(e){
            console.log("error", e , JSON.stringify(e))
            toast.error("Something went wrong, please try again later.");
    
        }
    }
    
    const nav = async( ) =>{
        await handleShow()
        await dispatch(changeHomeTab("4"))
        props.history.push("/datatypelist")
    }

  const handleChange = (event) => {
      const { name, value } = event.target;
      setValues({
          ...values,
          [name]: value,
      });
  };

  const handleClose = () => {
    onClose(false);
  };
  
  
  const saveDataType = async (event) => {
   // alert("consentType  :"+consentType);
    event.preventDefault();
    if (datatype === null || datatype.trim() === '') {
      toast.error("Datatype cannot be empty")
    }else if(consentType === null || consentType === undefined){
      toast.error("Data Category cannot be empty")
    }
    else {
      try {
        await dispatch(createDatatype(datatype, format, consentType));
        await dispatch(getDatatype())
        await handleShowDataTypeSuccess()
        onClose(false);
    } catch (e) {
        console.log("error", e, JSON.stringify(e))
        toast.error("Something went wrong, please try again later.");

    }
    }
    //toast.success('Datatype created successfully')
    closeDTModal();
    setDatatype(null);
}

const closeDTModal = () => {
    setShowDataTypeModal(!showDataTypeModal)

}

const handleShow = () => setShow(!show);
    const handleShowDataTypeSuccess = () => {
        setShowDataTypeSuccess(!showDataTypeSuccess);
        setShowDataTypeModal(!showDataTypeModal);
    }

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        open={open}
        className='custom-diaog-sm'
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <div className='row'>
            <div className='col-md-12'>
              <h3 className='pop-title'>Create Data Type</h3>
            </div>
          </div>
          <div class="card custom-cards dark no-shadow my-4">
            <div class="card-body">
              <div className='row'>
                <div className='col-md-12'>
                  <div className="mb-3">
                    <TextField label="Data Type" variant="standard" className='w-100'
                        onClick={(event) => {
                        if (!/^[ a-zA-Z ]/.test(event.key) ) { 
                            event.preventDefault(); 
                        }
                        }}
                        required 
                        onChange={(event)=> setDatatype(event.target.value)}
                    />
                  </div>
                  <div className='mb-3'>
                    <TextField
                      fullWidth
                      size='small'
                      label='XSD'
                      value="xsd"
                      variant='standard'
                      name='select1'
                      
                      onChange={(event)=> setFormat(event.target.value)}
                    >
                    </TextField>
                  </div>
                  <div className="mb-3">
                    {/* <TextField label="Data Category" variant="standard" className='w-100'
                    
                    /> */}
                     <div className="form-group mb-1">
                      <label className="mb-0 font-weight-bold">Data Category: </label>   
                      <TagsInput selectedTags={selectedTags}  tags={[]}/>
                  </div> 
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 text-end'>
            {/* <button type="button" onClick={closeDTModal} className='btn btn-outline-primary me-2'>Close</button> */}
                <button type="button" onClick={saveDataType} className='btn btn-primary'>Create</button>
            </div>
          </div>
        </DialogContent>
      </BootstrapDialog>
        <Modal show={show} onHide={handleShow} backdrop="static">
            <Modal.Header >
                <Modal.Title>Successful!!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>Your data type has been saved successfully.</span>
            </Modal.Body>
            <Modal.Footer>
                <button  type='submit' className="btn btn-outline-primary " onClick={nav}>Ok</button>
            </Modal.Footer>
        </Modal>

        {/* <ToastContainer 
                            // type={toastType}
                            // theme={'colored'}
                            /> */}
        
      
        <TimeoutLogic/>
    </>    
  );
};

export default CreateData;
